import useBrandColor from '@/lib/hooks/useBrandColor'
import usePlatformColor from '@/lib/hooks/usePlatformColor'
import { useRouter } from 'expo-router'
import { SymbolView } from 'expo-symbols'
import { Pressable, StyleSheet, Text } from 'react-native'

// The system mounts one copy per placement (regular and inline). On
// react-native-screens 4.25 / iOS 26.5 both copies are drawn on top of each
// other, so they must render identically — and stay stateless.
export default function JiriAccessory() {
  const router = useRouter()
  const tintColor = useBrandColor()
  const [placeholderColor] = usePlatformColor('secondaryLabel')

  return (
    <Pressable
      accessibilityRole="button"
      accessibilityLabel="问问 Jiri"
      onPress={() => router.push('/jiri')}
      style={styles.container}
    >
      <SymbolView name="sparkles" tintColor={tintColor} style={styles.icon} />
      <Text style={[styles.label, { color: placeholderColor }]} numberOfLines={1}>
        问问 Jiri…
      </Text>
    </Pressable>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    paddingHorizontal: 16,
  },
  icon: {
    width: 20,
    height: 20,
  },
  label: {
    flex: 1,
    fontSize: 16,
  },
})
